import { useEffect, useRef, useState } from "react";
import * as list from "src/core/statics/form-data/form-data";
import { useTranslation } from "react-i18next";
import SelectForms from "./select-forms-component";
import ChangePasswordFormComponent from "./popup-change-password-form-component";
function ParentEditProfileFormComponent() {
  const [country, setCountry] = useState("");
  const [eduSystem, setEduSystem] = useState("");
  const [showCountryOptions, setShowCountryOptions] = useState<boolean>(false);
  const [showEduSystemOptions, setShowEduSystemOptions] =
    useState<boolean>(false);
  const [isCountrySelected, setIsCountrySelected] = useState<boolean>(false);
  const [isEduSystemSelected, setIsEduSystemSelected] =
    useState<boolean>(false);
  const [showChangePasswordForm, setShowChangePasswordForm] =
    useState<boolean>(false);
  const changePasswordFormRef = useRef<HTMLDivElement>(null);
  const { i18n, t } = useTranslation();
  const handleClickOnCountryOption = (item: string) => {
    setCountry(item);
    setIsCountrySelected(true);
    setShowCountryOptions(false);
  };
  const handleClickOnEduSystemOption = (item: string) => {
    setEduSystem(item);
    setIsEduSystemSelected(true);
    setShowEduSystemOptions(false);
  };
  useEffect(() => {
    const handleClickOutSideForm = ({ target }: MouseEvent) => {
      if (!changePasswordFormRef?.current?.contains(target as Node)) {
        setShowChangePasswordForm(false);
      }
    };
    document.body.addEventListener("click", handleClickOutSideForm, true);

    return () => {
      document.body.removeEventListener("click", handleClickOutSideForm);
    };
  }, []);
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col items-center gap-10"
    >
      <div className="flex-col justify-center gap-4 inline-flex">
        <div className="flex flex-col gap-2">
          <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
            {t("registerForm.component.fullName")}
          </label>
          <input
            id="fullName"
            type="text"
            className="border-zinc400 focus:border-mint-500 w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500"
            placeholder={`${t("placeholder.fullName.fullNameExample")}`}
          ></input>
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
            {t("registerForm.component.email")}
          </label>
          <input
            id="email"
            type="text"
            className="border-zinc400 focus:border-mint-500 w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500"
            placeholder="a@example.sa"
          ></input>
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
            {t("registerForm.component.userName")}
          </label>
          <input
            id="userName"
            type="text"
            className="border-zinc400 focus:border-mint-500 w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-screen mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500"
            placeholder="a-a12"
          ></input>
        </div>
        <SelectForms
          currrentValue={
            country === ""
              ? i18n.language === "ar"
                ? list.country[0]
                : list.countryEn[0]
              : country
          }
          showOptions={showCountryOptions}
          isSelected={isCountrySelected}
          onClickOnDropDown={() => setShowCountryOptions(!showCountryOptions)}
          onClickOnOption={(item) => handleClickOnCountryOption(item)}
          label={t("forms.component.country")}
          options={i18n.language === "ar" ? list.country : list.countryEn}
        />
        <SelectForms
          label={t("searchBar.component.academicSystem")}
          options={i18n.language === "ar" ? list.edusystem : list.edusystemEn}
          currrentValue={
            eduSystem === ""
              ? i18n.language === "ar"
                ? list.edusystem[0]
                : list.edusystemEn[0]
              : eduSystem
          }
          showOptions={showEduSystemOptions}
          isSelected={isEduSystemSelected}
          onClickOnDropDown={() =>
            setShowEduSystemOptions(!showEduSystemOptions)
          }
          onClickOnOption={(item) => handleClickOnEduSystemOption(item)}
        />
        <div className="flex flex-col gap-2">
          <label className="text-zinc700 text-xl font-arMedium">
            {t("registerForm.component.password")}
          </label>
          <p
            onClick={() => setShowChangePasswordForm(true)}
            className="w-32 text-mint-500 py-4 text-lg font-arMedium leading-[27px] cursor-pointer"
          >
            {t("app.shared.changePassword")}
          </p>
        </div>
      </div>
      <button className="w-[162px] h-[43px] p-2 bg-mint-500 rounded-xl text-white text-lg font-arMedium">
        {t("app.shared.save")}
      </button>
      {showChangePasswordForm && (
        <ChangePasswordFormComponent changePasswordFormRef={changePasswordFormRef}/>
      )}
    </div>
  );
}

export default ParentEditProfileFormComponent;
